enum TradeError {
    INSUFFICIENT_GAS_FEE = 105101027, //  Gas费用不足
    INSUFFICIENT_TOKEN = 105101035, //  主链币余额不够租赁费用
    INSUFFICIENT_TOKEN_1 = 105101036, //  主链币余额不够租赁费用，请额外充值
    INSUFFICIENT_BALANCE = 105101037, //  余额不足交易。由于链上费用波动，需在钱包中预留 xx个tokenA 作为交易费用
}

export const isSufficientBalance = (code: number) => {
    return [
        TradeError.INSUFFICIENT_BALANCE,
        TradeError.INSUFFICIENT_GAS_FEE,
        TradeError.INSUFFICIENT_TOKEN,
        TradeError.INSUFFICIENT_TOKEN_1,
    ].includes(Number(code));
};

export default TradeError;
